// @flow
import * as React from 'react';
import styled from "styled-components";
import { SwitchToggle } from '../../../components';
import colors from '../../../assets/css/colors';

const AutoPickTogglerWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	padding: 10px 20px;
	min-width: 150px;
  	background: ${({ is_active }) => is_active ? colors.nrlDarkGreen : '#FFF'};
  	
  	.toggle-state-text {
  		color: ${({ is_active }) => is_active ? '#FFF' : colors.darkGrey};
  	}
  	
  	.auto-pick-toggle {
  		input:checked + label {
  			background: #FFF;
  			
  			&:before {
				background: ${colors.nrlDarkGreen};
			}
  		}
  	}
	
	div {
		text-align: center;
		margin-right: 0;
		
		label {
			margin: 0 auto 10px;
		}
	}
	
	
	p {
		width: 100%;
		
		label {
			color: ${colors.darkGrey};
			font-weight: bold;
			cursor: pointer;
		}
	}
	@media screen and (max-width: 480px){
		min-width: 100px;
		padding: 10px;
	}
`;

type Props = {
	isAutoPickEnabled: boolean | typeof undefined,
	onChange: Function,
}

export const AutoPickToggle = ({ isAutoPickEnabled, onChange }: Props) => (
	<AutoPickTogglerWrapper is_active={!!isAutoPickEnabled}>
		<div>
			<SwitchToggle
				value={!!isAutoPickEnabled}
				onChange={onChange}
				id="auto_pick"
				name="auto_pick"
				className="auto-pick-toggle"
			/>
			<p>
				<label className="toggle-state-text" htmlFor="auto_pick">
					AUTO PICK { !!isAutoPickEnabled ? 'ON' : 'OFF' }
				</label>
			</p>
		</div>
	</AutoPickTogglerWrapper>
);

export default AutoPickToggle;


// WEBPACK FOOTER //
// ./src/pages/league/liveDraft/autoPickToggle.js